import type { IconData } from '@stacksjs/iconify-core'

export const checkCircle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M426.072 86.928A238.75 238.75 0 0 0 88.428 424.572A238.75 238.75 0 0 0 426.072 86.928M257.25 462.5c-114 0-206.75-92.748-206.75-206.75S143.248 49 257.25 49S464 141.748 464 255.75S371.252 462.5 257.25 462.5\"/><path fill=\"currentColor\" d=\"m221.27 305.808l-73.413-73.412l-22.627 22.627l96.04 96.04l167.5-167.499l-22.628-22.627z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default checkCircle
